import * as URLS from "./XRSAPIs";
import Context from "./context";
import { ApiErrorHandler } from "utils/apiErrorHandler";
import { store } from "../store/redux/createReduxStore";
import { resetStore } from "../store/redux/redux-actions/redux_actions";

export default class Auth {
  userProfile = {};
  static context = Context;

  makeFormEncoder = (hash) => {
    return function (key) {
      return encodeURIComponent(key) + "=" + encodeURIComponent(hash[key]);
    };
  };

  getBearerToken = (username, password) => {
    var xhr = new XMLHttpRequest();
    var url = URLS.AuthenticationAPIUrl;

    var values = {
      grant_type: "password",
      username: username,
      password: password,
      validatePIN: "false",
      client_id: "PaymentPortal",
    };
    const pairs = Object.keys(values).map(this.makeFormEncoder(values));

    xhr.open("POST", url, true);
    xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");

    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        if (xhr.status == 200 || xhr.status == 201) {
          var json = JSON.parse(xhr.responseText);
          var access_token = json.access_token;
          var expires_in_seconds = json.expires_in;
          var timeoutDate;
          timeoutDate = new Date();
          timeoutDate.setSeconds(timeoutDate.getSeconds() + expires_in_seconds);
          sessionStorage.setItem("expiresAt", timeoutDate);
          sessionStorage.setItem("access_token", access_token);
        } else {
          ApiErrorHandler("Authentication", xhr, this.context);
        }
      }
    };
    var postValues = pairs.join("&");
    xhr.send(postValues);
  };

  RefreshToken = () => {
    var xhr = new XMLHttpRequest();
    var url = URLS.GetTokenURLAPI;

    let refresh_token = sessionStorage.getItem("refresh_token");
    var formValues = {
      grant_type: "refresh_token",
      client_id: "PaymentPortal",
      refresh_token: refresh_token,
    };
    const pairs = Object.keys(formValues).map(this.makeFormEncoder(formValues));
    xhr.open("POST", url, true);
    xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        if (xhr.status == 200 || xhr.status == 201) {
          var json = JSON.parse(xhr.responseText);
          var access_token = json.access_token;
          var refresh_token = json.refresh_token;
          var expires_in_seconds = json.expires_in;
          var timeoutDate;
          timeoutDate = new Date();
          timeoutDate.setSeconds(timeoutDate.getSeconds() + expires_in_seconds);
          sessionStorage.setItem("expiresAt", timeoutDate);
          sessionStorage.setItem("access_token", access_token);
          sessionStorage.setItem("refresh_token", refresh_token);
        } else {
          ApiErrorHandler("Authentication", xhr, this.context);
        }
      }
    };
    var postValues = pairs.join("&");
    xhr.send(postValues);
  };

  getAccessToken = () => {
    if (sessionStorage.getItem("access_token")) {
      const accessToken = sessionStorage.getItem("access_token");
      return accessToken;
    } else {
      return null;
    }
  };

  logout = (navigate) => {
    const token = sessionStorage.getItem("access_token");
    if (token) {
      fetch(URLS.LogoutURL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      }).then(() => {
        sessionStorage.removeItem("access_token");

        //sessionStorage.removeItem("id_token");
        sessionStorage.removeItem("expiresAt");
        sessionStorage.removeItem("refresh_token");
        sessionStorage.removeItem("user");
        // ;
        store.dispatch(resetStore());
        debugger;
        navigate("/landing-page");
      });
    }

    // history.push("/landing-page");
  };
  logoutOnCloseTab = () => {
    const token = sessionStorage.getItem("access_token");

    if (token) {
      const url = URLS.LogoutOnCloseURL;
      const data = JSON.stringify({
        token,
      });

      // Use navigator.sendBeacon to ensure logout request is sent
      const success = navigator.sendBeacon(url, data);

      if (success) {
        // Clear session storage and reset the store
        sessionStorage.removeItem("access_token");
        sessionStorage.removeItem("expiresAt");
        sessionStorage.removeItem("refresh_token");
        sessionStorage.removeItem("user");
        store.dispatch(resetStore());
      } else {
        console.error("Failed to send logout beacon");
      }
    }
  };

  isAuthenticated = () => {
    let expiresAt = JSON.parse(sessionStorage.getItem("expiresAt"));

    return new Date().getTime() < expiresAt;
  };

  isAuthenticatedUser = () => {
    let expiresAt = new Date(sessionStorage.getItem("expiresAt"));
    let now = new Date();
    now.setSeconds(now.getSeconds());
    if (now.getTime() < expiresAt.getTime()) {
      return true;
    } else {
      return false;
    }
  };

  checkToken = () => {
    let expiresAt = new Date(sessionStorage.getItem("expiresAt"));
    let now = new Date();
    now.setSeconds(now.getSeconds() + 10);
    if (now.getTime() < expiresAt.getTime()) {
    } else {
      this.RefreshToken();
    }
  };

  // getPinVerification = (values, record, pin) => {
  //   var xhr = new XMLHttpRequest();
  //   var url = URLS.GetVerifyAPIUrl;
  //   var id = record.id;
  //   var userName = values.regusername;
  //   var password = values.pass;
  //   var phoneConfirmed = record.phoneConfirmed;
  //   var reference = values.customernumber;
  //   var dateOfBirth = values.dob;
  //   var mobileNumber = values.phone;
  //   var customerRecordNo = record.customerRecordNo;
  //   var enteredPIN = pin;
  //   xhr.open("POST", url, true);
  //   xhr.setRequestHeader("Content-Type", "application/json");
  //   var verifydata = JSON.stringify({
  //     id: id,
  //     userName: userName,
  //     phoneConfirmed: phoneConfirmed,
  //     reference: reference,
  //     dateOfBirth: dateOfBirth,
  //     mobileNumber: mobileNumber,
  //     customerRecordNo: customerRecordNo,
  //     pin: enteredPIN,
  //   });

  //   xhr.onreadystatechange = function() {
  //     if (xhr.readyState === 4) {
  //       if (xhr.status == 200 || xhr.status == 201) {
  //         var xhrtoken = new XMLHttpRequest();
  //         var urltoken = URLS.GetTokenURLAPI;

  //         var values = {
  //           grant_type: "password",
  //           username: userName,
  //           password: password,
  //           validatePIN: "false",
  //           client_id: "PaymentPortal",
  //         };
  //         // eslint-disable-next-line no-case-declarations
  //         const pairs = Object.entries(values)
  //           .map(
  //             ([key, value]) =>
  //               `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
  //           )
  //           .join("&");

  //         xhrtoken.open("POST", urltoken, true);
  //         xhrtoken.setRequestHeader(
  //           "Content-Type",
  //           "application/x-www-form-urlencoded"
  //         );

  //         xhrtoken.onreadystatechange = function() {
  //           if (xhrtoken.readyState === 4) {
  //             if (xhr.status == 200 || xhr.status == 201) {
  //               var json = JSON.parse(xhrtoken.responseText);
  //               var access_token = json.access_token;
  //               var expires_in_seconds = json.expires_in;
  //               var timeoutDate;
  //               timeoutDate = new Date();
  //               timeoutDate.setSeconds(
  //                 timeoutDate.getSeconds() + expires_in_seconds
  //               );
  //               sessionStorage.setItem("expiresAt", timeoutDate);
  //               sessionStorage.setItem("access_token", access_token);
  //               this.isUserAuthenticated = true;
  //               this.token = access_token;
  //               navigate(`/welcome`);
  //             } else {
  //               ApiErrorHandler("Authentication", xhr, this.context);
  //             }
  //           }
  //         };

  //         xhrtoken.send(pairs);
  //       } else {
  //         ApiErrorHandler("Authentication", xhr, this.context);
  //       }
  //     }
  //   };

  //   xhr.send(verifydata);
  // };
}
